import { createContext } from "react";
export const PreferencesAppContext = createContext(null);
